import { RootState } from '../../../applicationStore';
import { TypeOfPaymentState } from '../reducers';
import { createSelector } from '@reduxjs/toolkit';

export const getTypeOfPaymentState = (state: RootState): TypeOfPaymentState =>
  state.typeOfPayment;

export const getTypeOfPaymentLoader = createSelector(
  getTypeOfPaymentState,
  (state): boolean => state.loading,
);

export const getTypeOfPaymentData = createSelector(
  getTypeOfPaymentState,
  (state): TypeOfPaymentState['data'] | null => state?.data || null,
);
